/** Traductions modal ajout client (FR / AR) */
export const addCustomerModalFr = {
  title: 'Ajouter Client',
  sectionInfo: 'Informations du Client',
  nameLabel: 'Nom',
  namePlaceholder: 'Nom du client (optionnel)',
  emailPlaceholder: 'Email (optionnel)',
  phoneLabel: 'Téléphone',
  phonePlaceholder: 'Téléphone (optionnel)',
  addressLabel: 'Adresse',
  addressPlaceholder: 'Adresse (optionnel)',
  statusLabel: 'Statut',
  statusActive: 'Actif',
  statusInactive: 'Inactif',
  statusPending: 'En Attente',
  joinedDateLabel: 'Date d\'Adhésion',
  joinedDatePlaceholder: 'Date d\'adhésion (optionnel)',
  notesLabel: 'Notes',
  notesPlaceholder: 'Notes sur le client (optionnel)',
  cancel: 'Annuler',
  submit: 'Ajouter Client',
  nameOrPhoneRequired: 'Veuillez saisir au moins un nom ou un numéro de téléphone.'
};

export const addCustomerModalAr = {
  title: 'إضافة عميل',
  sectionInfo: 'معلومات العميل',
  nameLabel: 'الاسم',
  namePlaceholder: 'اسم العميل (اختياري)',
  emailPlaceholder: 'البريد الإلكتروني (اختياري)',
  phoneLabel: 'الهاتف',
  phonePlaceholder: 'رقم الهاتف (اختياري)',
  addressLabel: 'العنوان',
  addressPlaceholder: 'العنوان (اختياري)',
  statusLabel: 'الحالة',
  statusActive: 'نشط',
  statusInactive: 'غير نشط',
  statusPending: 'في الانتظار',
  joinedDateLabel: 'تاريخ الانضمام',
  joinedDatePlaceholder: 'تاريخ الانضمام (اختياري)',
  notesLabel: 'الملاحظات',
  notesPlaceholder: 'ملاحظات على العميل (اختياري)',
  cancel: 'إلغاء',
  submit: 'إضافة العميل',
  nameOrPhoneRequired: 'يرجى إدخال الاسم أو رقم الهاتف على الأقل.'
};
